import React from 'react';
import styled from 'styled-components';
import {
  BenchMark,
  BrandAstraNavigator,
  EnterPriseCompatibility,
  GenAI,
  HolisticView,
  Multichannel,
  Publishing,
  UnderstandLanguage,
  WhyTrends,
} from '../../../Common/SvgIcon/CommonSvgIcons';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '1800px',
};

export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};

const Wrapper = styled.div`
  padding-top: 60px;
  background: #e6f0f0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 60px;
`;

const Title = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 32px;
  padding-top: 60px;
  padding-left: 60px;
  padding-bottom: 15px;
  padding-right: 60px;

  text-align: center;
  vertical-align: middle;
  background-image: linear-gradient(90deg, #063257 0%, #006867 100%);
  color: transparent;
  background-clip: text;
  @media only screen and ${device.tablet} {
    font-size: 28px;
    padding-top: 60px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
  }
`;

const Container = styled.div`
  background: radial-gradient(
    96.95% 124.13% at 1.95% 3.05%,
    rgba(226, 243, 187, 0.71) 0%,
    rgba(157, 200, 187, 0.71) 100%
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 40px;
  padding-bottom: 60px;
  padding-left: 10px;
  padding-right: 10px;
  @media only screen and ${device.tablet} {
    padding: unset;
    width: 345px;
    padding-bottom: 60px;
  }
`;
const SubTitle = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 20px;

  text-align: center;
  color: #2a876c;
  max-width: 555px;
  @media only screen and ${device.tablet} {
    font-size: 14px;
    max-width: 297px;
  }
`;
const GridContainer = styled.div`
  max-width: 1140px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 40px;
  @media only screen and ${device.tablet} {
    max-width: 297px;
  }
`;

const IndividualGrid = styled.div`
  width: 235px;
  height: 100px;
  border-radius: 10px;
  padding: 16px;
  background: #70af9d80;
  text-align: left;
  margin-top: 15px;
  @media only screen and ${device.tablet} {
    width: 120px;
    height: 146px;
    padding: 10px;
  }
`;

const GridTitle = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 20px;

  vertical-align: middle;
  color: #063257;
  text-align: left;
  @media only screen and ${device.tablet} {
    font-size: 18px;
  }
`;

const GridDescription = styled.div`
  font-family: Inter;
  font-weight: 500;
  font-size: 14px;

  margin-top: 15px;
  vertical-align: middle;
  color: #006867;
  @media only screen and ${device.tablet} {
    font-size: 12px;
  }
`;
const dataArray = [
  {
    title: 'Analyze Consumer Sentiment at Scale',
    description: 'Real-time digital listening across 50+ channels.',
  },
  {
    title: 'Anticipate Market Trends',
    description: 'AI-driven insights to stay ahead of emerging behaviors.',
  },
  {
    title: 'Track Brand Perception',
    description: 'Understand what consumers are saying and why.',
  },
  {
    title: 'Sentiment Analysis',
    description: 'Decode the ‘why’ behind emotional trends.',
  },
  {
    title: 'Engagement Analysis',
    description: 'Understand the ‘why’ behind audience reactions.',
  },
  {
    title: 'Influencer Identification',
    description: 'Discover key voices shaping conversations in your industry.',
  },
  {
    title: 'Competitive Intelligence',
    description: 'Compare your brand’s positioning vs. competitors.',
  },
  {
    title: 'AI-Powered Insights',
    description: 'Drill deeper, ask questions, and refine data on the go.',
  },
  {
    title: 'Access Data from Various Sources',
    description: 'Social media, news, e-commerce, forums, and more.',
  },
  {
    title: 'Instant Query Builder',
    description: 'No technical skills required, just ask what you need.',
  },
  {
    title: 'Customizable Dashboards',
    description: 'View insights the way that works best for you.',
  },
  // {
  //   title: 'Real-Time Alerts & Reports',
  //   description: 'Stay updated on key market shifts as they happen.',
  // },
  {
    title: 'Seamless Team Collaboration',
    description: 'Assign roles, create reports, and work smarter.',
  },
  {
    title: 'Export & Share Insights',
    description:
      'Download reports for offline review or share with your team instantly.',
  },
  {
    title: 'Global Reach with 45+ Languages',
    description: 'Break language barriers and analyze worldwide data.',
  },
  {
    title: 'PerceptMap',
    description:
      'Group similar conversations & trends to identify larger patterns in consumer sentiments. ',
  },
  {
    title: 'AskIQ',
    description:
      'Tailor insights based on specific brand objectives and deep-dive into unique data points. ',
  },
  {
    title: 'EngageMap',
    description:
      'Visualize engagement intensity based on key metrics across platforms and regions. ',
  },
  {
    title: 'Insight Grid',
    description:
      'Track engagement and user metrics to reveal patterns and correlations. ',
  },
];
const AllTheFeatures = () => {
  return (
    <Wrapper>
      <Container>
        <Title>
          All the Features, Without the Price Tag 
          <span style={{ fontWeight: 400 }}>(Free Trial for 15 Days)</span>
        </Title>
        <SubTitle>
          A truly AI-driven consumer intelligence platform packed with premium
          features.
        </SubTitle>
        <GridContainer>
          {dataArray?.map((data, index) => {
            return (
              <IndividualGrid
                data={index}
                style={{
                  marginLeft:
                    window?.innerWidth > 768
                      ? index !== 0 || (index + 1) / 4 !== 0
                        ? '15px'
                        : undefined
                      : (index + 1) % 2 !== 1
                      ? '10px'
                      : undefined,
                }}
              >
                <GridTitle>{data?.title}</GridTitle>
                <GridDescription>{data?.description}</GridDescription>
              </IndividualGrid>
            );
          })}
        </GridContainer>
      </Container>
    </Wrapper>
  );
};

export default AllTheFeatures;
